import { store as auth } from '@/modules/core/auth'
import { store as home } from '@/modules/core/home'
import { store as course } from '@/modules/widgets/course'

export default {
  auth,
  home,
  course
}
